module.exports = __webpack_public_path__ + "img/menu-icon-close.2bb7c585.svg";